import { render } from "./IndividualForm.vue?vue&type=template&id=cd034c0e&scoped=true"
import script from "./IndividualForm.vue?vue&type=script&lang=js"
export * from "./IndividualForm.vue?vue&type=script&lang=js"

import "./IndividualForm.vue?vue&type=style&index=0&id=cd034c0e&scoped=true&lang=css"
import "./IndividualForm.vue?vue&type=style&index=1&id=cd034c0e&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\Asistenca\\old-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd034c0e"]])

export default __exports__